import { createSelector } from 'reselect';
import { filter } from 'ramda';

import { createFilter } from './FilterUtil';

const getOpportunities = state => state.entities.opportunities.items;
const getOpportunitiesFilter = state => state.entities.opportunities.filter;

const opportunityMatchesFilter = (o, filter) =>
  !filter ||
  (o.title && o.title.toLowerCase().indexOf(filter) > -1) ||
  (o.description && o.description.toLowerCase().indexOf(filter) > -1) ||
  (o.tags && o.tags.length > 0 && o.tags.indexOf(filter) > -1);

export const selectOpportunitiesFiltered = createSelector(
  [getOpportunities, getOpportunitiesFilter],
  (items, filterValue) =>
    filterValue ? filter(createFilter(filterValue.toLowerCase(), opportunityMatchesFilter), items) : items
);



// WEBPACK FOOTER //
// ./src/selectors/OpportunitiesSelector.js